export default __webpack_public_path__ + "static/media/A0005.2e3a6acd.png";